import React from "react";

/* BACKGROUND IMAGE IMPORT */
import bgImage from "../../../assets/overview_img/integration/maroon-bg.jpg";

export default function ContactSection() {
  return (
    <section
      className="
        w-full
        lg:h-[1000px]


        overflow-hidden

        bg-cover
        bg-center
        bg-no-repeat
      "
      style={{
        backgroundImage: `url(${bgImage})`,
      }}
    >
      <div
        className="
          max-w-[1400px]

          mx-auto

          grid
          grid-cols-1
          lg:grid-cols-2

          lg:h-[1000px]
        "
      >
        {/* LEFT CONTENT */}
        <div
          className="
            flex
            items-start
            justify-center
            flex-col

            px-6
            sm:px-10
            lg:px-20

            py-16

            lg:-mt-[400px]
            lg:-ml-[30px]

            text-white
          "
        >
         

          {/* BIG BOLD TEXT */}
          <h1 className="leading-none">
  <span
    className="
      block
      text-white
      lg:font-light

      text-[38px]
      sm:text-[55px]
      lg:text-[52px]

      font-light
    "
  >
    See how DailyPay
  </span>

  <span
    className="
      block

      text-white

      text-[42px]
      sm:text-[70px]
      lg:text-[58px]

      lg:font-sans
      lg:w-[700px]

      mt-2
      lg:mt-4
    "
  >
    can help your company
  </span>
</h1>
          {/* PARAGRAPH */}
          <p
            className="
              mt-8

              text-[15px]
              sm:text-[17px]
              lg:text-[15px]

              leading-[1.6]

              font-[400]

              max-w-[520px]

              text-white
            "
          >
            Join hundreds of leading employers who are transforming their
            workplaces with On-Demand Pay. Connect with our team to discover
            how DailyPay can drive retention, boost engagement, and deliver
            measurable ROI for your organization.
          </p>
        </div>

       {/* RIGHT FORM */}
<div
  className="
    flex
    items-center
    justify-center

    px-4
    sm:px-8
    lg:px-0
    lg:mr-[100px]

    py-6

    lg:h-[1000px]
  "
>
  <div
    className="
      w-full
      max-w-[470px]
      lg:max-w-[500px]

      bg-white

      rounded-[4px]

      p-6
      lg:p-7

      shadow-2xl

      h-auto
      lg:min-h-[820px]
    "
  >
    {/* NAME ROW */}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        <label className="
         text-[13px]
        font-serif
        mb-0
                    text-black">
          First Name <span className="text-red-500">*</span>
        </label>

        <input
          type="text"
          className="
            mt-2
            lg:mt-0

            w-full
            h-[48px]

            border
            border-[#cfcfcf]

            px-4

            outline-none
          "
        />
      </div>

      <div>
        <label className=" text-[13px]
                    font-serif
                    mb-0
                    text-black">
          Last Name <span className="text-red-500">*</span>
        </label>

        <input
          type="text"
          className="
            mt-2
            lg:mt-0

            w-full
            h-[48px]

            border
            border-[#cfcfcf]

            px-4

            outline-none
          "
        />
      </div>
    </div>

    {/* DEPARTMENT */}
    <div className="mt-5 lg:mt-2">
      <label className=" text-[13px]
                    font-serif
                    mb-0
                    text-black">
        Department <span className="text-red-500">*</span>
      </label>

      <select
        className="
          mt-2
          lg:mt-0

          w-full
          h-[48px]

          border
          border-[#cfcfcf]

          px-4

          outline-none
        "
      >
        <option>Select...</option>
      </select>
    </div>

    {/* EMAIL */}
    <div className="mt-5 lg:mt-2">
      <label className=" text-[13px]
                    font-serif
                    mb-0
                    text-black">
        Work Email <span className="text-red-500">*</span>
      </label>

      <input
        type="email"
        className="
          mt-2
          lg:mt-0

          w-full
          h-[48px]

          border
          border-[#cfcfcf]

          px-4

          outline-none
        "
      />
    </div>

    {/* PHONE */}
    <div className="mt-5 lg:mt-3">
      <label className=" text-[13px]
                    font-serif
                    mb-0
                    text-black">
        Phone Number <span className="text-red-500">*</span>
      </label>

      <input
        type="text"
        className="
          mt-2
          lg:mt-0

          w-full
          h-[48px]

          border
          border-[#cfcfcf]

          px-4

          outline-none
        "
      />
    </div>

    {/* COMPANY */}
    <div className="mt-5 lg:mt-2">
      <label className=" text-[13px]
                    font-serif
                    mb-0
                    text-black">
        Company Name <span className="text-red-500">*</span>
      </label>

      <input
        type="text"
        className="
          mt-2
          lg:mt-0

          w-full
          h-[48px]

          border
          border-[#cfcfcf]

          px-4

          outline-none
        "
      />
    </div>

    {/* EMPLOYEES */}
    <div className="mt-5 lg:mt-3">
      <label className=" text-[13px]
                    font-serif
                    mb-0
                    text-black">
        Number of Employees <span className="text-red-500">*</span>
      </label>

      <input
        type="text"
        className="
          mt-2
          lg:mt-0

          w-full
          h-[48px]

          border
          border-[#cfcfcf]

          px-4

          outline-none
        "
      />
    </div>

    {/* MESSAGE */}
    <div className="mt-5 lg:mt-3">
      <label className=" text-[13px]
                    font-serif
                    mb-0
                    text-black">
        How can we help?
      </label>

      <textarea
        className="
          mt-2
          lg:mt-0

          w-full
          h-[100px]

          border
          border-[#cfcfcf]

          p-4

          resize-none

          outline-none
        "
      />
    </div>

    {/* BUTTON */}
    <button
      className="
        mt-7

        bg-[#1e0202]

        text-white

        px-6
        py-2.5

        text-[16px]

        font-bold

        hover:bg-[#2a0000]

        transition-all
      "
    >
      Let's Talk
    </button>

    {/* CAPTCHA */}
    <p
      className="
        mt-6

        text-[11px]

        text-[#8a8a8a]

        italic

        leading-[1.5]
      "
    >
      This site is protected by reCAPTCHA.
    </p>
  </div>
</div>
      </div>
    </section>
  );
}